import React from 'react';
import { AlertTriangle, CheckCircle2, Phone } from 'lucide-react';
export function Safety() {
  const checklist = ['Pull over safely if the damage blocks your view or distracts you while driving.', 'Do not drive if loose glass, spreading cracks or blocked visibility make the vehicle unsafe.', 'Avoid touching shattered glass with bare hands.', 'Cover broken side or rear windows only if it can be done safely and temporarily.', 'Take a clear photo of the damaged glass if possible.', "Call Kosin's Glass or request an urgent quote.", 'Have your vehicle year, make, model and insurance information ready.', 'Ask whether ADAS calibration may be needed after windshield replacement.'];
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-slate-50 border-y border-slate-200" data-id="element-196">
      <div className="max-w-4xl mx-auto" data-id="element-197">
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden" data-id="element-198">
          <div className="p-6 sm:p-10 border-b border-slate-100" data-id="element-199">
            <div className="flex items-start gap-4" data-id="element-200">
              <div className="bg-brand-redLight p-3 rounded-lg shrink-0" data-id="element-201">
                <AlertTriangle className="w-7 h-7 text-brand-red" data-id="element-202" />
              </div>
              <div data-id="element-203">
                <div className="text-xs font-bold uppercase tracking-wider text-brand-red mb-2" data-id="element-204">
                  Safety First
                </div>
                <h2 className="text-2xl sm:text-4xl font-black text-slate-900 leading-tight tracking-tight" data-id="element-205">
                  What To Do When Your{' '}
                  <span className="text-brand-red" data-id="element-206">
                    Windshield or Car Window Breaks
                  </span>
                </h2>
              </div>
            </div>
          </div>

          <div className="p-6 sm:p-10" data-id="element-207">
            <ul className="space-y-4 mb-8" data-id="element-208">
              {checklist.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-209">
                  <span className="shrink-0 mt-0.5 w-6 h-6 rounded-full border-2 border-brand-red flex items-center justify-center" data-id="element-210">
                    <CheckCircle2 className="w-3.5 h-3.5 text-brand-red" strokeWidth={3} data-id="element-211" />
                  </span>
                  <span className="text-slate-700 leading-relaxed" data-id="element-212">{item}</span>
                </li>)}
            </ul>

            <div className="text-center pt-4 border-t border-slate-100" data-id="element-213">
              <a href="tel:517-545-7772" className="inline-flex items-center justify-center gap-2 bg-brand-red hover:bg-brand-redHover text-white px-7 py-4 rounded-lg font-bold text-base transition-colors shadow-sm w-full sm:w-auto" data-id="element-214">
                <Phone className="w-5 h-5" data-id="element-215" />
                Call Kosin's Glass for Emergency Help
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}